const orange = '#FF6C36';
const gray = '#303133';
const blue = '#2D8CF0';
const green = '#19BE6B';
const yellow = '#FF9900';
const red = '#FA5555';

const carDescs = [
  {
    icon: 'icon-force',
    title: '強制險',
    content: '法令規定需購買之險種，僅提供身體損傷的基本保障',
    color: gray
  },
  {
    icon: 'icon-hurt',
    title: '第三人責任險\n體傷責任險',
    content: '開車碰到人第三人體傷',
    color: orange,
    class: 'text-center'
  },
  {
    icon: 'icon-loss',
    title: '第三人責任險\n財損責任險',
    content: '開車碰到車第三人財損',
    color: orange,
    class: 'text-center'
  },
  {
    icon: 'icon-excess',
    title: '超額責任險',
    content: '撞到名車不用怕超額責任',
    color: orange,
    class: 'text-center'
  },
  {
    icon: 'icon-litigation',
    title: '刑事訴訟補償',
    content: '過失傷害被告刑事訴訟費用',
    color: blue
  },
  {
    icon: 'icon-passenger',
    title: '乘客責任險',
    content: '開車疏失乘客受傷乘客責任',
    color: green
  },
  { 
    icon: 'icon-help', 
    title: '道路救援', 
    content: '車輛故障拖吊費用', 
    color: yellow,
    class: 'text-center'
  },
  { 
    icon: 'icon-push', 
    title: '丙式車體', 
    content: '本車與他車發生碰撞、擦撞所致之損失，確認事故對造車輛後，保險公司對本車負賠償責任。', 
    color: orange,
    class: 'text-center'
  }
];

const travelDescs = [
  {
    icon: 'icon-airplane',
    title: '旅行平安保險',
    content: '身故保險金或失能保險金。\n例：旅途中遭受意外傷害事故致死或失能。',
    color: orange
  },
  {
    icon: 'icon-medical',
    title: '傷害醫療保險',
    content: '旅途中因為意外就醫，在登記合格的醫院或是診所就醫所產生的醫療花費。超過全民健康保險給付部分，給付傷害醫療保險金。',
    color: green
  },
  {
    icon: 'icon-disease',
    title: '海外突發疾病保險',
    content: '旅途中發生突發疾病，接受門診或住院治療。\n例：旅途中因食物中毒上吐下瀉就醫等。',
    color: yellow
  },
  {
    icon: 'icon-luggage',
    title: '旅遊不便綜合險',
    content: '除了保障人身安全，旅遊不便險主要針對旅遊班機延誤、行李延誤及行李遺失...造成的損失補償。',
    color: blue
  },
  {
    icon: 'icon-sad',
    title: '旅遊責任保險',
    content: '不小心造成第三人體傷、死亡、財物損失，在保額內所需負擔的賠償責任。\n例：不慎打破商家物品、住宿飯店不慎引起火災等。',
    color: red
  }
];

const motorDescs = [
  {
    icon: 'icon-force',
    title: '強制險',
    content: '法令規定需購買之險種，僅提供身體損傷的基本保障',
    color: gray
  },
  {
    icon: 'icon-motor-hurt',
    title: '第三人責任險\n傷害責任險',
    content: '騎車碰到人第三人體傷',
    color: orange,
    class: 'text-center'
  },
  {
    icon: 'icon-motor-loss',
    title: '第三人責任險\n財損責任險',
    content: '騎車碰到車第三人財損',
    color: orange,
    class: 'text-center'
  },
  {
    icon: 'icon-ambulance',
    title: '第三人責任險\n附加慰問金',
    content: '第三人體傷，醫院探訪的住院慰問金',
    color: orange
  },
  {
    icon: 'icon-motor-passenger',
    title: '乘客責任險',
    content: '騎車疏失乘客受傷乘客責任',
    color: green
  },
];

const accidentDescs = [
  {
    icon: 'icon-medical',
    title: '意外傷害保險',
    content: '身故保險金或失能保險金。\n例：遭受非由疾病引起之外來突發意外傷害事故致死或失能。',
    color: orange
  },
  {
    icon: 'icon-force',
    title: '傷害醫療保險',
    content: '因為非由疾病引起之外來突發意外傷害就醫，在登記合格的醫院或是診所就醫所產生的醫療花費。超過全民健康保險給付部分，給付傷害醫療保險金。',
    color: green
  },
  {
    icon: 'icon-fire',
    title: '火災意外保險',
    content: '意外發生超出正常範圍之燃燒狀態所造成的災害，致其身體蒙受傷害而致失能或死亡。',
    color: yellow
  },
  {
    icon: 'icon-earthquake',
    title: '地震意外險',
    content: '因遭受地震發生意外傷害事故，致其身體蒙受傷害而致失能或死亡。',
    color: blue
  },
  {
    icon: 'icon-passenger',
    title: '大眾運輸工具意外保險',
    content: '以乘客身分於搭乘大眾運輸工具期間發生意外傷害事故，致其身體蒙受傷害而致失能或死亡。',
    color: red
  }
];

const petDescs = [
  {
    icon: 'icon-paw',
    title: '寵物醫療保險',
    content: '被保險寵物於保險契約有效期間內因第三條約定之疾病或傷害，經登記合格獸醫診療機構進行診療者，對被保險人就每一被保險寵物每一事故實際所支出之醫療費用。',
    color: orange
  },
  {
    icon: 'icon-paw',
    title: '侵權責任保險',
    content: '被保險人在保險期間內因被保險寵物之行為致第三人體傷、死亡或財物損害，依法應負賠償責任而受賠償請求時，對被保險人負賠償之責。',
    color: green
  },
  {
    icon: 'icon-paw',
    title: '協尋廣告保險',
    content: '被保險寵物於保險期間內遺失時，就每一被保險寵物自發現遺失實際所發生之媒體或印刷品等協尋廣告費用給付保險金。',
    color: yellow
  },
  {
    icon: 'icon-paw',
    title: '寄宿日額險',
    content: '被保險人於保險期間內，因疾病或遭受意外傷害事故，經登記合格的醫院診治必須住院者，因連續住院日數達三日以上（含入院與出院日），於住院期間無法照護被保險寵物，致寄託被保險寵物於登記合格獸醫院或合法設立之寵物業，保險公司就被保險人實際所支出寵物寄宿費用，依照本契約所約定保險金額內，給付「寵物寄宿日額費用」保險金。',
    color: yellow
  },
  {
    icon: 'icon-paw',
    title: '喪葬費用保險',
    content: '被保險寵物因第三條約定之疾病或遭受意外傷害事故致死，就每一被保險寵物對被保險人實際支出之寵物喪葬費用給付保險金。',
    color: blue
  },
  {
    icon: 'icon-paw',
    title: '遺失安置收容費用保險',
    content: '被保險寵物於保險期間內遺失時，保險公司就被保險寵物自發現遺失三十日內被保險人實際所發生之動物收容所管理費，給付「寵物遺失安置收容費用」保險金。',
    color: red
  },
  /*{
    icon: 'icon-paw',
    title: '旅遊行程取消保險',
    content: '以乘客身分於搭乘大眾運輸工具期間發生意外傷害事故，致其身體蒙受傷害而致失能或死亡。',
    color: red
  }*/
];
const vaccineDescs = [
  {
    icon: 'icon-vainnce',
    title: '疫苗保障綜合險',
    content: '疫苗不良事件費用補償、法定傳染病疫苗保障實支實付住院醫療',
    color: gray
  },
  {
    icon: 'icon-ambulance',
    title: '法定傳染病隔離費用補償險',
    content: '法定傳染病隔離費用補償',
    color: orange,
    class: 'text-center'
  }
]; 


const travel = {
  title: '了解你擔心什麼？選擇合適方案',
  descs: travelDescs
};

const car = {
  title: '買對車險，讓您人車皆保障',
  descs: carDescs
};

const motor = {
  title: '保障不能少，出門更安心',
  descs: motorDescs
};

const accident = {
  title: '了解你擔心什麼？選擇合適方案',
  descs: accidentDescs
};
const pet = {
  title: '了解你擔心什麼？選擇合適方案',
  descs: petDescs
};

const vaccine = {
  title: '了解你擔心什麼？選擇合適方案',
  descs: vaccineDescs
};

export default {
  travel,
  car,
  motor,
  accident,  
  pet,        
  vaccine  //20210530 Wen Add
};


export const ageLimit = {
  columns: [
    { title: '年齡', key: 'age', minWidth: 200, fixed: 'left' },
    { title: '旅行平安險投保限額(NT$)', minWidth: 200, key: 'safe' },
    { title: '旅行平安失能保險金投保限額(NT$)', minWidth: 250, key: 'disabled' },
    { title: '傷害醫療投保限額(NT$)', minWidth: 200, key: 'medical' }
  ],
  data: [
    {
      age: '滿15歲~未滿20歲',
      safe: '500萬',
      disabled: '-',
      medical: '50萬'
    },
    {
      age: '滿20歲~未滿70歲',
      safe: '1000萬',
      disabled: '-',
      medical: '150萬'
    },
    {
      age: '滿70歲~未滿75歲',
      safe: '500萬',
      disabled: '-',
      medical: '50萬'
    },
    {
      age: '滿75歲~未滿80歲',
      safe: '200萬',
      disabled: '-',
      medical: '20萬'
    },
    {
      age: '滿80歲~未滿86歲',
      safe: '100萬',
      disabled: '-',
      medical: '-'
    }
  ]
};